import { render, staticRenderFns } from "./BranchLink.vue?vue&type=template&id=4176066b&scoped=true&"
import script from "./BranchLink.vue?vue&type=script&lang=js&"
export * from "./BranchLink.vue?vue&type=script&lang=js&"
import style0 from "./BranchLink.vue?vue&type=style&index=0&id=4176066b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4176066b",
  null
  
)

export default component.exports